import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import styled from 'styled-components';

const MobilePage = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
      window.document.body.scrollTop = 0;
      window.document.documentElement.scrollTop = 0;
    }

    if (typeof document !== 'undefined') {
      document.querySelectorAll<HTMLElement>('[data-mobile-scroll]').forEach(el => {
        el.scrollTop = 0;
      });
    }
  }, [location.pathname, location.search]);

  return (
    <PageWrapper>
      <Content>
        <Outlet />
      </Content>
    </PageWrapper>
  );
};

export default MobilePage;

const PageWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
`;

const Content = styled.div`
  padding: 70px 0 2px;
`;

